/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_ConfirmedInputs */

const en_platform_preview_confirmed = /** @type {(inputs: Platform_Preview_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed`)
};

const pl_platform_preview_confirmed = /** @type {(inputs: Platform_Preview_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdzone`)
};

/**
* | output |
* | --- |
* | "Confirmed" |
*
* @param {Platform_Preview_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_confirmed = /** @type {((inputs?: Platform_Preview_ConfirmedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_ConfirmedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_confirmed(inputs)
	return en_platform_preview_confirmed(inputs)
});